<template>
  <div class="logistics">
    <header>
      <div class="top">
        <span class="back"
              @click="back()">
          <img src="@/assets/images/return.png" />
        </span>
        <h3>物流详情</h3>
      </div>
    </header>
    <div class="content">
      <div class="base_info">
        <p>
          {{logistics_detail.logistics_name}}：{{logistics_detail.logistics_no}}
          <img @click="copy"
               src="@/assets/images/copy_icon.png" />
          <textarea class="input"></textarea>
        </p>
      </div>
      <div class="lines"></div>
      <div class="logistics_infos">
        <van-steps direction="vertical"
                   :active-color="$theme_color"
                   :active="0">
          <van-step v-for="(item,index) in logistics_detail.content"
                    :key="index">
            <h3>{{item.AcceptStation}}</h3>
            <p>{{item.AcceptTime}}</p>
          </van-step>
        </van-steps>
      </div>
    </div>
  </div>
</template>

<script>
import icon from '@/assets/images/question-checkbox-hover.png';
export default {
  name: "logistics",
  components: {
  },
  data () {
    return {
      iconActive: icon,
      id: null,
      logistics_detail: {}
    };
  },
  computed: {

  },
  created () {
    this.id = this.$route.query.order_id;
    this.getLogistics();
  },
  methods: {
    getLogistics () {
      this.$http.get(`/api/app/comment/getLogistics`, { order_id: this.id }).then(res => {
        this.logistics_detail = res;
      });
    },
    copy () {
      let text = this.logistics_detail.logistics_no;
      let input = document.getElementsByClassName("input")[0];
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$toast("复制成功");
    },
    back(){
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logistics {
  @extend %default-bg;
  font-family: PingFang SC;
  background-color: #fff;
  header {
    .top {
      height: 88px;
      position: relative;
      background-color: #fff;
      .back {
        display: block;
        width: 90px;
        height: 100%;
        float: left;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 19px;
          transform: translate(-50%, -50%);
        }
      }
      h3 {
        font-size: 36px;
        font-weight: bold;
        color: #333;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .content {
    border-top: 1px solid #f6f6f6;
    .base_info {
      font-size: 28px;
      color: #333333;
      padding: 30px;
      img {
        width: 26px;
        height: 26px;
        margin-left: 20px;
      }
      .input {
        opacity: 0;
        width: 0;
        height: 0;
      }
    }
    .lines {
      height: 30px;
      background-color: #f6f6f6;
    }
    .logistics_infos {
      padding: 0 30px;
      margin-top: 30px;
      /deep/ {
        .van-steps {
          .van-steps__items {
            .van-step__title {
              line-height: 36px;
              font-size: 30px;
              p {
                font-size: 28px;
                margin-top: 10px;
              }
            }
          }
          .van-icon {
            font-size: 30px;
          }
          .van-step__circle {
            width: 10px;
            height: 10px;
          }
          .van-step__line {
            top: 40px;
          }
          .van-step--vertical .van-step__circle-container {
            top: 50px;
          }
        }
      }
    }
  }
}
</style>